import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import { Months, TPeriodicItems } from '../types/Wallet.types';
import {
  decrementJalaliMonth,
  incrementJalaliMonth,
  incrementJalaliYear,
} from './incrementJalaliMonth';

const MONTH_LIST = [
  'farvardin',
  'ordibehesht',
  'khordad',
  'tir',
  'mordad',
  'shahrivar',
  'mehr',
  'aban',
  'azar',
  'dey',
  'bahman',
  'esfand',
];

export function yearlyReportPayloadNormalizer(
  monthList: Array<TPeriodicItems>,
) {
  const firstMonth = {
    id: decrementJalaliMonth(monthList[0].id),
    month: Months[Number(decrementJalaliMonth(monthList[0].id).split('-')[1])],
    year: decrementJalaliMonth(monthList[0].id).split('-')[0],
    isDisable: false,
  };

  const cookedMonthList = [
    firstMonth,
    ...monthList.filter((item) => !Boolean(item.isDisabled)),
  ];

  let months = {};

  const year = {
    start_date: convertPersianToGregorian(`${cookedMonthList[0].id}-1`),
    end_date: convertPersianToGregorian(
      `${incrementJalaliYear(cookedMonthList[0].id)}-0`,
    ),
  };

  for (let i = 0; i < 12; i++) {
    Object.assign(months, {
      [MONTH_LIST[Number(cookedMonthList[i].id.split('-')[1]) - 1]]: {
        fa_name: `${Months[Number(cookedMonthList[i].id.split('-')[1])]} ${cookedMonthList[i].id.split('-')[0]}`,
        start_date: convertPersianToGregorian(`${cookedMonthList[i].id}-1`),
        end_date: convertPersianToGregorian(
          `${incrementJalaliMonth(cookedMonthList[i].id)}-0`,
        ),
      },
    });
  }
  return { year, months };
}
